// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ITextStyles, ITheme, Stack, Text, useTheme } from '@fluentui/react';

export const FeedbackDialogHeader = (props: { feedbackSubmitted: boolean }): JSX.Element => {
  const theme = useTheme();
  return (
    <Stack tokens={{ childrenGap: '0.5rem' }}>
      <Stack.Item>
        <Text styles={titleTextStyles(theme)}>
          {props.feedbackSubmitted ? 'Feedback Submitted' : 'Submit Feedback'}
        </Text>
      </Stack.Item>
      {!props.feedbackSubmitted && (
        <Stack.Item>
          Please submit your feedback using the form below:
          <Text styles={subtitleTextStyles(theme)}></Text>
        </Stack.Item>
      )}
    </Stack>
  );
};

const titleTextStyles = (theme: ITheme): ITextStyles => ({
  root: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: theme.palette.themePrimary
  }
});

const subtitleTextStyles = (theme: ITheme): ITextStyles => ({
  root: {
    fontSize: '0.8rem',
    fontWeight: 600,
    color: theme.palette.neutralSecondary
  }
});
